import { BLACK } from '../../../constants/colors'

export class AccessoryPart {
  public color = BLACK //color for displaying the accessory
  public orderPosition = 0 //color for displaying the accessory

  constructor(public id: string) {}

  public matches(other: AccessoryPart): boolean {
    return this.id === other.id
  }
}
